module.exports = __webpack_public_path__ + "img/eagleeye.e404c185.png";